import * as yup from 'yup';
import { ResponsiveImage } from '../../components/';
import { getMediaQuery, getSrcSets, storyblokAspectRatio } from '../images';

export const Component = ResponsiveImage;
export const schema = yup
  .object()
  .shape({
    alt: yup.string().required(),
    picture: yup.boolean().required(),
    images: yup.array().of(
      yup
        .object()
        .shape({
          image: yup.object().shape({
            filename: yup.string().required(),
          }),
          breakpoint: yup.string().oneOf(['mobile', 'desktop', 'tablet']),
          width: yup.string().required(),
        })
        .required(),
    ),
  })
  .transform(({ alt, images }) => {
    let defaultSrc;
    // these build individual source dom nodes
    const srcSets = images.map(({ image, breakpoint, width }) => {
      if (breakpoint === 'desktop') {
        defaultSrc = image.filename;
      }

      return {
        srcSet: getSrcSets(image.filename),
        aspectRatio: storyblokAspectRatio(image.filename),
        sizes: width,
        media: getMediaQuery(breakpoint),
      };
    });

    return {
      alt,
      picture: true,
      srcSet: srcSets,
      src: defaultSrc,
    };
  });
